<template>
	<v-dialog v-model="dialog" max-width="800px">
		<v-card :class="contrastOnSecondary" color="secondary">
			<v-card-title class="font-weight-bold text-h5 mb-2">
				Pricing
				<v-spacer />
				<v-icon icon dark @click="close">mdi-close</v-icon>
			</v-card-title>
			<v-card-subtitle class="white--text">Pay when you book option is default unless Subscription is completed. *T's & C's apply</v-card-subtitle>
			<v-card-text>
				<v-container class="white--text">
					<v-row>
						<v-col cols="12" sm="12" md="6">
							<div class="text-h6 pb-3 font-weight-bold">Pay when you book</div>
							<div>- 15% Facilitation Fee on Locum Bookings</div>
							<div>- 10% Facilitation Fee on Permanent Placements</div>
							<div>- Earn 5% of Locum Rate in LocumCredits for future bookings*</div>
						</v-col>
						<v-col cols="12" sm="12" md="6">
							<div class="text-h6 pb-3 font-weight-bold">Pro Practice Membership</div>
							<div>- R450 per month</div>
							<div>- 7.5% Facilitation Fee on Locum Bookings</div>
							<div>- 5% Facilitation Fee on Permanent Placements</div>
							<div class="pt-6 text-center">
								<v-btn
									href="https://www.payfast.co.za/eng/process?cmd=_paynow&receiver=19388754&item_name=LocumBase+Practice+Subscription&email_confirmation=1&confirmation_address=webmaster@locumbase.com&item_description=R450+per+month7.5+percent+Facilitation+Fee+on+Locum+bookings5++percent+Facilitation+Fee+on+Permanent+bookings&return_url=https://app.locumbase.com&cancel_url=https://www.locumbase.com/cancelled-payment&notify_url=https://www.locumbase.com/subscription-completed&amount=450&subscription_type=1&recurring_amount=450&cycles=0&frequency=3"
									target="_blank"
									@click="trackButton"
								>
									Subscribe Now
								</v-btn>
							</div>
						</v-col>
					</v-row>
				</v-container>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import { Tracking } from '@/utils';

export default {
	name: 'PricingDialog',

	data() {
		return {
			dialog: false,
		};
	},

	computed: {},

	methods: {
		open() {
			this.dialog = true;
			Tracking.track('Pricing_Open');
		},

		close() {
			this.dialog = false;
		},

		trackButton() {
			Tracking.track('Subscribe_Button');
		},
	},
};
</script>

<style scoped></style>
